/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from "react";
import SessionData from "../../../services/session-data";
import axios from "axios";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useStyles } from "../../Styles/mui-styles";
import "../../../styles/main-style.css";
import "react-tagsinput/react-tagsinput.css";
import Chip from "@material-ui/core/Chip";
import Paper from "@material-ui/core/Paper";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import AppBarAndDrawer from "../../Dashboard/AppBarAndDrawer";
import { Breadcrumbs, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import { Stack } from "@mui/material";

export default function RegisterPouchItems() {
  const [pouchIns, setpouchIns] = useState<string>("");
  const [valueStore, setValueStore] = useState<any>([]);
  const [dialog, setDialog] = useState("hidden");
  const [open, setOpen] = React.useState(false);
  const [dMessage, setDMessage] = React.useState("");
  const [pouchInstrumentList, setPouchInstrumentList] = useState<any[]>([]);
  const finalObj: any = {
    pouchIns: [],
  };

  const classes = useStyles();

  useEffect(() => {
    getPouchInstruments();
  }, []);

  //removing a value from array when clicking on a chip tag
  const handleDelete = (tagToDelete: any) => () => {
    setValueStore((tag) => valueStore.filter((tag) => tag !== tagToDelete));
  };

  const handleClose = () => {
    setOpen(false);
  };

  //Fetch All Pouch Instruments from API
  const getPouchInstruments = () => {
    const sd = new SessionData();
    axios
      .get(sd.getBaseURL() + "web-register/getpouchinstruments", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + sd.getClientToken(),
        },
      })
      .then((data) => {
        if (data.status !== 200) throw new Error("List empty");
        setPouchInstrumentList(data.data);
      })
      .catch((err) => {});
  };

  //check if value is provided by user
  const formValidation = () => {
    if (valueStore.length <= 0 && pouchIns.length <= 0) {
      setDMessage("Please add atleast one Item");
      setOpen(true);
      return;
    }
    //insert values in final array
    finalObj.pouchIns.push(...valueStore);

    if (pouchIns.length > 0) finalObj.pouchIns.push(pouchIns);
    RegisterpouchIns();
  };

  const RegisterpouchIns = () => {
    const sd = new SessionData();
    setDialog("hidden");
    // finalObj.oosReasons.push(pouchIns)

    axios
      .post(
        sd.getBaseURL() + "web-register/addpouchins",
        {
          finalObj,
        },
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + sd.getClientToken(),
            "staff-auth": "Bearer " + sd.getStaffToken(),
          },
        }
      )
      .then((data) => {
        if (data.status !== 201)
          throw new Error("Error, Not able to insert data");
        setDMessage("New Pouch Item(s) Added");
        setOpen(true);
      })
      .catch((err) => {});
    //empty everything
    setpouchIns("");
    setValueStore([]);
  };

  const errorDialog = () => {
    return (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Pouch Instruments</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {dMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  //insert values in array
  const handleNewTag = (value) => {
    //if the last character is a comma,  then empty the service reasons
    if (value.charAt(value.length - 1) === ",") {
      const tagToAdd = value.substring(0, value.length - 1);
      //check if tag already in array
      if (valueStore.filter((tag) => tag === tagToAdd).length <= 0) {
        setValueStore((oldArray) => [...oldArray, tagToAdd]); //get the value from pouchIns and add in to array
        setpouchIns(""); //empty setpouchIns
      } else {
        setpouchIns("");
        setDMessage("Value Already exists in the list");
        setOpen(true);
      }
    } else {
      setpouchIns(value);
    }
  };

  return (
    <>
      <AppBarAndDrawer />
      <div style={{ marginLeft: "260px" }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" to="/">
            Home
          </Link>
          <Typography color="textPrimary">Register Pouch Items</Typography>
        </Breadcrumbs>

        <div
          className="container dFlex dFlexCol"
          style={{ width: "80%", height: "80%", justifyContent: "center" }}
        >
          <h2 className="text-center jFontBold">Add Pouch Instruments</h2>
          <Paper className="jPadding box-shadow">
            <form>
              <div className="form-group">
                <label htmlFor="autoclaveName">Pouch Instruments</label>
                {/* <input
                  type="text"
                  className="form-control"
                  required
                  onChange={(e) => handleNewTag(e.target.value)}
                  value={pouchIns}
                  id="autoclaveName"
                  aria-describedby="emailHelp"
                  placeholder="separate multiple items with comma(,)"
                ></input> */}
                <Stack spacing={2}>
                  <Autocomplete
                    id="autoclaveName"
                    freeSolo
                    options={pouchInstrumentList.map(
                      (option) => option.pouch_instruments
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        onChange={(e) => handleNewTag(e.target.value)}
                        placeholder="separate multiple items with comma(,)"
                        label="Add Pouch Items"
                      />
                    )}
                    value={pouchIns}
                    onChange={(event, newValue) => handleNewTag(newValue)}
                  />
                </Stack>
              </div>
              <div className={classes.displayFlex}>
                {valueStore.map((tag, index) => {
                  return (
                    <>
                      <li key={index}>
                        <Chip
                          color="primary"
                          label={tag}
                          onDelete={handleDelete(tag)}
                          className={classes.chip}
                        />
                      </li>
                    </>
                  );
                })}
              </div>
              <button
                type="button"
                onClick={formValidation}
                className="btn btnColor btn-lg"
              >
                Submit
              </button>
            </form>
            <div className="row">
              {/* <div className="col" >
                    <div style={myStyles} >Please fill autoclave name, cycle no, and bowie dick to register</div>
                </div> */}
            </div>
          </Paper>
        </div>
        {open === true ? errorDialog() : ""}
      </div>
    </>
  );
}
